<template>
  <ul class="flex flex-wrap items-center gap-12 pt-6" data-test="social-links">
    <li v-for="social in socials" :key="social.name" class="contents">
      <RevLink
        :data-test="`${social.name}-link`"
        itemprop="sameAs"
        :name="`footer_${social.name}`"
        target="_blank"
        :title="`${COMPANY_NAME} - ${social.name}`"
        :to="social.href"
        :underlined="false"
      >
        <RevIllustration
          alt=""
          class="h-32 w-32"
          :height="30"
          :src="`/img/socials/${social.name}-light.svg`"
          :width="30"
        />
      </RevLink>
    </li>
  </ul>
</template>

<script setup lang="ts">
import { useRuntimeConfig } from '#imports'

import { RevIllustration } from '@ds/components/Illustration'
import { RevLink } from '@ds/components/Link'

import type { FooterSocialNetwork } from '../config/types'

interface Props {
  socials: FooterSocialNetwork[]
}

defineProps<Props>()

const { COMPANY_NAME } = useRuntimeConfig().public
</script>
